/**
 * Handle Slat sizes links in PDP
 *
 * @param {}
 * @return {void}
 */

$(document).on('change', '.js-slatsize-link', function() {
  const $this = $(this);
  const url = $this.data('url');

  window.open(window.location.origin + url, '_self');
});
